module.exports = __webpack_public_path__ + "static/media/catalog-icon.bb7f49af.svg";